import { render, staticRenderFns } from "./ConcatUs.vue?vue&type=template&id=153dae32&scoped=true&"
import script from "./ConcatUs.vue?vue&type=script&lang=js&"
export * from "./ConcatUs.vue?vue&type=script&lang=js&"
import style0 from "./ConcatUs.vue?vue&type=style&index=0&id=153dae32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153dae32",
  null
  
)

export default component.exports